import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";
// import './NewsEquity.css';
// import { useLocalStorage } from "../../utils/useLocalStorage";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate } from 'react-router-dom';
import { Modal, Container } from "react-bootstrap";
import renderHTML from 'react-render-html';
import { Vortex } from 'react-loader-spinner'


function MutualFundnews() {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  let getData;
  const { BaseURL } = useContext(URLstateContext);
  const [data, setData] = useState([]);
  const [loadingshow, setloadingshow] = useState(false);
  const [filteredNewsData, setFilteredNewsData] = useState([]);
  const [isActive, setActive] = useState("false");
  const [text, setText] = useState("More");
  const [companyInfo, setCompanyInfo] = useState([]);
  let companyInformation;
  let navigate = useNavigate();
  //{SecID}/{SubSecID}/{Sno}/{tot}
  useEffect(() => {
    setloadingshow(true);
    const newsUrl = BaseURL + "News/";
    // if (props.coCode != "") {
    fetch(`${newsUrl}/10/24/-/8`)
      .then((response) => response.json())
      .then((data) => {
        getData = data.data;
        setData(getData);

        companyInformation = data.data;
        setCompanyInfo(companyInformation);
        setloadingshow(false);
      })
      .catch((error) => {
        // console.log("not found the api 1233333");
      });
    // }
  }, []);

  // const handleClosePopup = () => {
  //   setShow(false);
  // }
  // const newsModal = (e) => {
  //   const fetchId = e.currentTarget.getAttribute('data-id');
  //   let filteredCompanyInformation = companyInfo.filter(oneData => { return parseInt(oneData['Sno']) === parseInt(fetchId) })
  //   //console.log(filteredCompanyInformation)

  //   setFilteredNewsData(filteredCompanyInformation)
  //   handleShow();
  // }

  const routeChange = (event) => {
    const fetchId = event.currentTarget.getAttribute('data-id');
    const fetchHead = event.currentTarget.getAttribute('data-head');
    window.open("/Detail-News/" + fetchId + "/" + fetchHead.replace(/ /g, '-').replace('&', 'and').replace('/', 'slash').replace(/\./g,'').replace('?', 'questionMark').replace('=', 'isEqualsTo').replace(':', 'colon').replace('%', 'Percent'), '_blank');
  };


  return (
    <>
      <div className='market-inner-common market-mf-main'>
        <div className='market-header'>
          <h4>Mutual Fund News</h4>
          <span className="moreContent" onClick={() => { navigate("/MutualFund/Mutual-Fund-News") }} tabIndex={0} >See More</span>
        </div>
        {(data === null) ? <div className="errorMsg"><h3>No Data Found !!!</h3></div> : ''}
        <Container className="add-border table-box">
          {(data != null) && data.map(
            ({ co_code, Sno, Heading, Date, Time, ArtText, memo }) => (
              <div className="IPOnews-wq">
                <div className="IPOnews-wq-inner">
                  <div className="IPOnews-wq-betaNews">
                    <div className="IPOnews-gutter">
                      {/* <a data-id={Sno} onClick={newsModal}>
                        <a> */}
                      <h6 className="text-left text headNew" tabIndex={0} onClick={routeChange} data-head={Heading} data-id={Sno} >{Heading} </h6>
                      <p className="text-left text"> {(Date.split('T')[0])}  ({Time})</p>
                      {/* </a>
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>

            ))}
          {loadingshow ? <div className="textcentervertex">
            <Vortex
              visible={true}
              height="80"
              width="80"
              ariaLabel="vortex-loading"
              wrapperStyle={{}}
              wrapperClass="vortex-wrapper"
              colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
            />
            <div className="model_popup">Please Wait...</div>
          </div> : ""
          }
          {/* {filteredNewsData &&
            filteredNewsData.map(({ co_code, Sno, Heading, Date, Time, Arttext, memo }) => (
              <Modal show={show} className="modal company-snap-modal">

                <Modal.Body id="modal_info">
                  <div className="titleCompany">{Heading}</div>
                  <div className="btnDiv">
                    <div className="btncl" onClick={handleClosePopup} > X </div>
                  </div>
                  <div className="infoCompany">{renderHTML(Arttext)}</div>
                </Modal.Body>

              </Modal>
            ))} */}
        </Container>

      </div>
    </>
  )
}

export default MutualFundnews